define(function () {
    'use strict';
    $('.overlay, .mask').fadeOut();
    $('#app-content').css('visibility', 'visible');
});



// WEBPACK FOOTER //
// ./src/js_modules/orderCodSuccessController.js